export const rtupdate = (rtupdatedata, reducer, parameter) => {
  return {
    type: "RealTimeUpdate for " + reducer,
    payload: rtupdatedata,
    parameter: parameter,
    reducer: reducer
  };
};
export const rtget = (rtgetdata, reducer) => {
  return {
    type: "RealTimeGetData",
    payload: rtgetdata
  };
};



// WEBPACK FOOTER //
// ./src/actions/realtime-data.js